const ko_Kr = {
    // homepage
    homepage_title: '캘린더 목록 모바일 버전 다운로드',
    homepage_slogn: '캘린더 목록 모바일 버전',
    homepage_ios_download: 'AppStore검토 중...',
    homepage_download: '지금 다운로드',

    
    // 手机下载
    phonedownload_title: '캘린더 목록 모바일 다운로드',
    phonedownload_slogan: '캘린더 목록의 모바일 버전은 컴퓨터 버전의 캘린더 목록과 실시간으로 동기화되어 언제 어디서나 퀴즈를 기록할 수 있습니다.',
    phonedownload_send_vip: '캘린더 목록 앱 설치, VIP 회원 보내기',
    phonedownload_screenshot: '스크린샷',
    phodedownload_macos: '캘린더 목록 macOS 컴퓨터 버전',
    phodedownload_windows: '캘린더 목록 Windows 컴퓨터 버전',
    phodedownload_otherbutton: "지금 보기",
    phodedownload_about: '문의하기',
    phodedownload_copyright: ' ',

    //特点
    feature_no_ad:'광고 없음',
    feature_easy:'월 뷰, 사용 편이성',
    feature_reminder:'사용자 정의 알림',
    feature_countdown:'카운트다운 기념일',

    vip_task_succ:'수령 성공, 핸드폰 버전 활성화 VIP 를 다운로드하세요',
    vip_task_error:'수령 실패',

    
    //课程表
    tt_title: 'CalendarTask',
    tt_share_1: '공유되었습니다',
    tt_share_2: '시간표',
    tt_share_show_1: '「CalendarTask」앱으로 QR 코드를 스하면 PC와 모바일에서 자동으로',
    tt_share_show_2: '시간표가 표시됩니다',
    tt_share_scan_1: ' ',
    tt_share_scan_2: '「CalendarTask」앱으로 스캔',
    tt_share_succ: '동기화 성공',
    
    // V2版权信息
    v2_copyright: '문의하기 service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. All rights reserved.',
    v2_download_appstore: 'Download on the App Store',
    v2_download_googleplay: 'GET IT ON Google Play',
    
    // V2中间部分内容
    v2_main_title: '캘린더 목록 모바일',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: '모바일',
    v2_main_description: 'App Store나 Google Play에서 <span class="name">CalendarTask</span> 를 검색하여 다운로드할 수 있습니다.',
    v2_download_ios: 'iOS 다운로드',
    v2_download_android: 'Android 다운로드',
    v2_download_harmonyos: 'HarmonyOS 다운로드',
    v2_sync_status: '동기화 완료! 1개 레코드 업로드, 0개 레코드 다운로드',
    v2_feature_title: '멀티 디바이스 데이터 동기화',
    v2_feature_description: '모바일, 태블릿, 컴퓨터 등 다양한 기기 간 실시간 데이터 동기화'

}
export default ko_Kr;